export default __webpack_public_path__ + "static/media/programme3.bc1e84d7.webp";